declare var jQuery:any;

export class VMWCBackboneModal {
    id:string;
    private static scrollLockCount: number = 0;
    private static prevBodyOverflow: string | null = null;
    private static prevBodyPaddingRight: string | null = null;
    constructor(id:string) {
        this.id = id;
    }

    /**
     * Reusable body-only scroll lock for other custom modals in admin.
     * Keeps a shared counter so nested modals don't unlock too early.
     */
    public static lockBodyScroll() {
        VMWCBackboneModal.lockScroll();
    }

    public static unlockBodyScroll() {
        VMWCBackboneModal.unlockScroll();
    }

    private static lockScroll() {
        // Support nested modals
        VMWCBackboneModal.scrollLockCount += 1;
        if (VMWCBackboneModal.scrollLockCount > 1) {
            return;
        }

        const body = document.body;
        const html = document.documentElement;
        if (!body || !html) {
            return;
        }

        // Save previous values so we can restore them
        VMWCBackboneModal.prevBodyOverflow = body.style.overflow;
        VMWCBackboneModal.prevBodyPaddingRight = body.style.paddingRight;

        // Compensate for scrollbar width to avoid layout shift
        const scrollbarWidth = window.innerWidth - html.clientWidth;
        if (scrollbarWidth > 0) {
            body.style.paddingRight = `${scrollbarWidth}px`;
        }

        // IMPORTANT: do not change `html` overflow; in WP-admin this can cause scroll jumps.
        body.style.overflow = 'hidden';
    }

    private static unlockScroll() {
        if (VMWCBackboneModal.scrollLockCount === 0) {
            return;
        }
        VMWCBackboneModal.scrollLockCount -= 1;
        if (VMWCBackboneModal.scrollLockCount > 0) {
            return;
        }

        const body = document.body;
        if (!body) {
            return;
        }

        body.style.overflow = VMWCBackboneModal.prevBodyOverflow ?? '';
        body.style.paddingRight = VMWCBackboneModal.prevBodyPaddingRight ?? '';

        VMWCBackboneModal.prevBodyOverflow = null;
        VMWCBackboneModal.prevBodyPaddingRight = null;
    }

    public clean_modal() {
        jQuery('#'+this.id+' span.settings_modal_title').empty();
        jQuery('#'+this.id+' div.modal-form-content').empty();
        jQuery('#'+this.id+' footer .inner').empty();  
    }

    public init_modal(title:string, content:string, footer: string) {
        jQuery('#'+this.id+' span.settings_modal_title').text(title);

        if(content){
            jQuery('#'+this.id+' div.modal-form-content').html(content);
        }

        if(footer){
            jQuery('#'+this.id+' footer .inner').html(footer);
        }
    }

    public showModal() {
        // Idempotency: some screens can trigger the same warning twice (click + submit handlers, etc.).
        // If the modal is already visible, don't lock scroll again (prevents scrollLockCount leaks).
        try {
            if (jQuery("#" + this.id).is(':visible')) {
                return;
            }
        } catch (_) { /* noop */ }
        VMWCBackboneModal.lockScroll();
        jQuery("#"+this.id).css('display', 'flex');
        jQuery("#wc-backbone-modal-dialog").css('position', 'fixed');
    }

    public closeModal() {
        jQuery("#"+this.id).hide();
        VMWCBackboneModal.unlockScroll();
    }
}
